import { ImageLoader } from '../../../ImageLoader';
import { TranslationsKeys, useCustomIntl } from '../../../../i18n/i18n';
import {
  getManualImageAsset,
  ImageBaseNames,
} from '../../../../components/dialog/userManualDialog/chapters/imageAssets';
import { useLocale } from '../../../../i18n/locale';
import useDarkMode from '@rio-cloud/rio-uikit/useDarkMode';

export const CardManagementImage = ({
  image,
  title,
}: {
  image: ImageBaseNames;
  title: TranslationsKeys;
}) => {
  const { locale } = useLocale();
  const { formatMessage } = useCustomIntl();
  const isDarkMode = useDarkMode();
  return (
    <ImageLoader
      src={getManualImageAsset(image, locale, isDarkMode)}
      alt={formatMessage({ id: title })}
      className="border"
      enlargeable
    />
  );
};
